<template>
  <div
    class="MapNavBar"
    :style="{width: $store.state.navBarWidth +'px', height: $store.state.windowHeight + 'px', opacity: $store.state.navBarWidth === 0 ? 0: 1}">

    <!--返回按钮-->
    <i class="return ico ico-round-left-fill" v-if="currentLevelMap !=='country'" @click="returnBack"></i>

    <!--企业搜索框-->
    <div class="search">
      <el-input placeholder="企业名称" v-model="inputCompany">
        <el-button slot="append" icon="el-icon-search" @click="searchCompany"></el-button>
      </el-input>
    </div>

    <!--设备显示列表-->
    <div>
      <!--显示省级设备列表-->
      <div class="deviceList provinceList" v-if="currentLevelMap === 'country'">
        <el-table
          :data="deviceMapList"
          :height="$store.state.windowHeight - 100"
          stripe
          @row-click="chooseProvince">
          <el-table-column
            label="省">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.province}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公司数量">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.companyNum}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--显示市级设备列表-->
      <div class="deviceList cityList" v-else-if="currentLevelMap === 'province'">
        <el-table
          :data="provinceMapList"
          stripe
          :height="$store.state.windowHeight - 100"
          @row-click="chooseCity">
          <el-table-column
            label="市">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.city}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公司数量">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.companyNum}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--显示区级设备列表-->
      <div class="deviceList areaList" v-else-if="currentLevelMap === 'city'">
        <el-table
          :data="cityMapList"
          stripe
          :height="$store.state.windowHeight - 100"
          @row-click="chooseArea">
          <el-table-column
            label="区">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.area}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="公司数量">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.companyNum}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--显示公司级设备列表-->
      <div class="companyMapList" v-else>
        <el-table
          :data="areaMapList"
          stripe
          :height="$store.state.windowHeight - 100">
          <el-table-column
            label="公司">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.companyName}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="设备数量">
            <template slot-scope="scope">
              <div class="deviceMapInfo">
                {{scope.row.deviceNum}}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 更多模块连接 -->
    <router-link class="moreLink" to="/Index">更多模块</router-link>
  </div>
</template>

<script>
  export default {
    name: 'MapNavBar',
    props: ['deviceMapList'],
    data() {
      return {
        commonUrl: '#/Map/',
        inputCompany:'',
        currentLevelMap:'country',   // country,province,city,area,company
        currentLocationMap: '广东',
        provinceMapList:[],
        cityMapList:[],
        areaMapList:[],
        tableHeight: ''
      }
    },
    mounted(){
      this.tableHeight = this.$store.state.windowHeight - 100
      // 加载页面时判断当前地图为 country,province,city,area,company
      // console.log('this.$route.params', this.$route.params.mapLevel)
      this.judgeCurrentLevelMap(this.$route.params.mapLevel)
    },
    created: async function () {
      // console.log(this.deviceMapList);
    },
    methods: {
      judgeCurrentLevelMap: function (mapLevel) {
        // if (mapLevel )
      },
      // 企业搜索
      searchCompany() {
        console.log(this.inputCompany);
      },
      // 省份选择
      chooseProvince(row) {
        let province = row.province,
            cityDeviceList = row.cityDeviceList

        this.cityDeviceList = [...cityDeviceList];
        this.currentLevelMap = 'province';
        //vuex保存currentLevelMap
        this.$store.commit('saveCurrentLevelMap','province');
        this.$store.commit('saveCurrentLocationMap',province);
        // 路由跳转
        let windowUrl = this.commonUrl + 'province' + '/' + province;
        window.location.href= windowUrl;
      },
      // 城市选择
      chooseCity(row) {
        let city = row.city,
            areaDeviceList = row.areaDeviceList

        this.cityMapList = [...areaDeviceList];
        this.currentLevelMap = 'city';
        //vuex保存currentLevelMap
        this.$store.commit('saveCurrentLevelMap','city');
        this.$store.commit('saveCurrentLocationMap',city);
        // 路由跳转
        let windowUrl = this.commonUrl + 'city' + '/' + city;
        window.location.href= windowUrl;
      },
      // 区选择
      chooseArea(row) {
        let area = row.area,
            companyDeviceList = row.companyDeviceList

        this.areaMapList = [...companyDeviceList];
        this.currentLevelMap = 'area';
        //vuex保存currentLevelMap
        this.$store.commit('saveCurrentLevelMap','area');
        this.$store.commit('saveCurrentLocationMap',area);
        // 路由跳转
        let windowUrl = this.commonUrl + 'area' + '/' + area;
        window.location.href= windowUrl;
      },
      // 设置当前地图
      setCurrentDeviceMapList(currentLevelMap,currentLocationMap) {
        switch (currentLevelMap) {
          case 'province':
            for(let i=0; i<this.deviceMapList.length; i++) {
              if(this.deviceMapList[i].province === currentLocationMap) {
                this.provinceMapList = [...this.deviceMapList[i].cityDeviceList];
                return;
              }
            }
            break;
          case 'city':
            for(let i=0; i<this.deviceMapList.length; i++) {
              for(let j=0; j<this.deviceMapList[i].cityDeviceList.length; j++) {
                if(this.deviceMapList[i].cityDeviceList[j].city === currentLocationMap) {
                  this.cityMapList = [...this.deviceMapList[i].cityDeviceList[j].areaDeviceList];
                  return;
                }
              }
            }
            break;
          case 'area':
            for(let i=0; i<this.deviceMapList.length; i++) {
              for(let j=0; j<this.deviceMapList[i].cityDeviceList.length; j++) {
                for(let k=0; k<this.deviceMapList[i].cityDeviceList[j].areaDeviceList.length; k++) {
                  if(this.deviceMapList[i].cityDeviceList[j].areaDeviceList[k].area === currentLocationMap) {
                    console.log('公司设备列表：',this.deviceMapList[i].cityDeviceList[j].areaDeviceList[k].companyDeviceList);
                    this.areaMapList = [...this.deviceMapList[i].cityDeviceList[j].areaDeviceList[k].companyDeviceList];
                    return;
                  }
                }
              }
            }
            break;
          default:
            break;
        }
      },
      // 返回上一级
      returnBack() {
        let lastLocationName = '';
        let windowUrl = '';
        switch (this.currentLevelMap) {
          case 'province':
            this.currentLevelMap = 'country';
            //vuex保存currentLevelMap
            this.$store.commit('saveCurrentLevelMap','country');
            lastLocationName = this.getLastLocationName('province',this.$store.state.currentLocationMap);
            this.$store.commit('saveCurrentLocationMap',lastLocationName);
            // 路由跳转
            windowUrl = this.commonUrl + 'country' + '/' + lastLocationName;
            window.location.href= windowUrl;
            break;
          case 'city':
            this.currentLevelMap = 'province';
            //vuex保存currentLevelMap
            this.$store.commit('saveCurrentLevelMap','province');
            lastLocationName = this.getLastLocationName('city',this.$store.state.currentLocationMap);
            this.$store.commit('saveCurrentLocationMap',lastLocationName);
            // 路由跳转
            windowUrl = this.commonUrl + 'province' + '/' + lastLocationName;
            window.location.href= windowUrl;
            break;
          case 'area':
            this.currentLevelMap = 'city';
            //vuex保存currentLevelMap
            this.$store.commit('saveCurrentLevelMap','city');
            lastLocationName = this.getLastLocationName('area',this.$store.state.currentLocationMap);
            this.$store.commit('saveCurrentLocationMap',lastLocationName);
            // 路由跳转
            windowUrl = this.commonUrl + 'city' + '/' + lastLocationName;
            window.location.href= windowUrl;
            break;
        
          default:
            break;
        }
      },
      // 获取上一级的地名
      getLastLocationName(currentLevel,currentLocation) {
        let lastLocationName = ''
        switch (currentLevel) {
          case 'province':
            lastLocationName = '广东';
            return (lastLocationName);
            break;
          case 'city':
            for(let i=0; i<this.deviceMapList.length; i++) {
              for (let j=0; j<this.deviceMapList[i].cityDeviceList.length; j++) {
                if(this.deviceMapList[i].cityDeviceList[j].city === currentLocation) {
                  lastLocationName = this.deviceMapList[i].province;
                  return (lastLocationName);
                }
              }
            }
            break;
          case 'area':
            for(let i=0; i<this.deviceMapList.length; i++) {
              for (let j=0; j<this.deviceMapList[i].cityDeviceList.length; j++) {
                for (let k=0; k<this.deviceMapList[i].cityDeviceList[j].areaDeviceList.length; k++) {
                  if(this.deviceMapList[i].cityDeviceList[j].areaDeviceList[k].area === currentLocation) {
                    lastLocationName = this.deviceMapList[i].cityDeviceList[j].city;
                    return (lastLocationName);
                  }
                }
              }
            }
            break;
          default:
            break;
        }
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.currentLevelMap":async function(newVal, oldVal) {
        this.currentLevelMap = this.$store.state.currentLevelMap;
        this.currentLocationMap = this.$store.state.currentLocationMap;
        console.log('地图导航组件：',this.currentLevelMap, this.currentLocationMap);
        this.setCurrentDeviceMapList(this.currentLevelMap, this.currentLocationMap);
      },
      "$store.state.currentLocationMap":async function(newVal, oldVal) {
        this.currentLevelMap = this.$store.state.currentLevelMap;
        this.currentLocationMap = this.$store.state.currentLocationMap;
        this.setCurrentDeviceMapList(this.currentLevelMap, this.currentLocationMap);
      },
    }
  }
</script>

<style lang="scss" scoped>
.MapNavBar {
  width: 256px;
  position: absolute;
  top: 0;
  left: 0;  
  .return {
    margin: 7.5px 0;
    font-size: 30px;
    font-weight: bold;
    color: #555555;
    position: absolute;
    left: 15px;
    top: 40px;
    z-index: 2;
  }
  .deviceList {
    .table {
    }
    .deviceMapInfo {
      padding: 3px;
      margin: -3px;
    }
  }
  .moreLink {
    line-height: 20px;
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/MapNavBar.vue